// @import

import Alpine from "alpinejs";

const links = {
  facebook: `popUp=window.open('http://www.facebook.com/sharer.php?u=${document.URL}','popupwindow','scrollbars=yes,width=800,height=400');popUp.focus();return false;`,
  twitter: `popUp=window.open('http://twitter.com/intent/tweet?text=${encodeURIComponent(
    document.URL,
  )}','popupwindow','scrollbars=yes,width=800,height=400');popUp.focus();return false`,
  linkedin: `popUp=window.open('http://www.linkedin.com/shareArticle?url=${document.URL}','popupwindow','scrollbars=yes,width=800,height=400');popUp.focus();return false`,
};

type SocialMedia = keyof typeof links;

Alpine.directive("social-share", (element, { expression }) => {
  const ensureSocial = (key: string): key is SocialMedia => Object.keys(links).includes(key);

  const socialMedia = ensureSocial(expression) ? expression : null;
  if (!socialMedia) {
    console.warn(
      `${socialMedia} sharing is not handled. Supported platforms are: ${Object.keys(links).join(", ")}`,
    );
    return element.remove();
  }

  element.setAttribute("onclick", links[socialMedia]);
});
